import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { AboutpageService } from 'src/app/features/company/about/aboutpage.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-team-overview',
  templateUrl: './team-overview.component.html',
  styleUrls: ['./team-overview.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class TeamOverviewComponent implements OnInit, OnDestroy {
  constructor(
    private contentful: ContentfulService,
    private aboutPageService: AboutpageService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  overviewData: any;

  ngOnInit(): void {
    this.aboutPageService.aboutOverview$.subscribe(data => {
      if (data != null) {
        this.overviewData = {
          image1: {
            url: data[0]?.fields?.image[0]?.fields?.file?.url || '',
            alt: data[0]?.fields?.image[0]?.fields?.title || '',
          },
          image2: {
            url: data[1]?.fields?.image[0]?.fields?.file?.url || '',
            alt: data[1]?.fields?.image[0]?.fields?.title || '',
          },
          heading1: data[0]?.fields?.title,
          heading2: data[1]?.fields?.title,
          paragraph1: data[0]?.fields?.content?.content[0],
          paragraph2: data[1]?.fields?.content?.content[0],
          // paragraph2bold: data?.content?.content[1]?.content[0]?.value || '',
          // paragraph2normal: data?.content?.content[1]?.content[1]?.value || '',
          // paragraph3bold: data?.content?.content[2]?.content[0]?.value || '',
          // paragraph3normal: data?.content?.content[2]?.content[1]?.value || '',
          button: {},
        };
      }
    });
  }
}
